// src/components/drawer/recipe.ts
import { tv } from "tailwind-variants";
var drawerSlotRecipe = tv({
  slots: {
    root: [],
    overlay: [
      "fixed",
      "inset-0",
      "z-[999999]",
      "bg-neutral-900/60",
      "data-[state=closed]:animate-drawer-overlay-fade-out",
      "data-[state=open]:animate-drawer-overlay-fade-in"
    ],
    content: [
      "fixed",
      "z-[999999]",
      "flex",
      "flex-col",
      "max-h-dvh",
      "bg-white"
    ],
    header: ["flex-[0_1_0%]", "border-b", "px-6", "py-4"],
    title: ["my-heading-sm"],
    body: ["flex-1", "overflow-auto", "p-6"],
    footer: [
      "flex",
      "items-center",
      "justify-between",
      "border-t",
      "px-6",
      "py-3"
    ]
  },
  variants: {
    placement: {
      bottom: {
        content: [
          "mt-8",
          "w-full",
          "left-0",
          "bottom-0",
          "rounded-t-xl",
          "data-[state=closed]:animate-drawer-content-bottom-slide-out",
          "data-[state=open]:animate-drawer-content-bottom-slide-in"
        ]
      },
      top: {
        content: [
          "mb-8",
          "w-full",
          "top-0",
          "right-0",
          "rounded-b-xl",
          "data-[state=closed]:animate-drawer-content-top-slide-out",
          "data-[state=open]:animate-drawer-content-top-slide-in"
        ]
      },
      start: {
        content: [
          "h-dvh",
          "w-full",
          "top-0",
          "left-0",
          "bottom-0",
          "max-w-full",
          "md:max-w-[668px]",
          "data-[state=closed]:animate-drawer-content-start-slide-out",
          "data-[state=open]:animate-drawer-content-start-slide-in"
        ]
      },
      end: {
        content: [
          "h-dvh",
          "w-full",
          "top-0",
          "right-0",
          "bottom-0",
          "max-w-full",
          "md:max-w-[668px]",
          "data-[state=closed]:animate-drawer-content-end-slide-out",
          "data-[state=open]:animate-drawer-content-end-slide-in"
        ]
      }
    }
  },
  defaultVariants: {
    placement: "end"
  }
});

export {
  drawerSlotRecipe
};
